module.exports = __webpack_public_path__ + "img/06.e33a4444.jpg";